<script lang="ts">
//
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  let authToken = "";
  let loading = false;

  const handleSubmit = () => {
    loading = true;
    dispatch("auth", authToken.trim());
  };

  const handleAnonymous = () => {
    loading = true;
    dispatch("auth", "");
  };
</script>

<div class="auth">
  <div class="auth-card">
    <h2>Real-time Chat</h2>

    <button on:click={handleAnonymous} disabled={loading} class="btn-primary">
      {loading ? "Connecting..." : "Join Anonymously"}
    </button>

    <div class="divider">or</div>

    <form on:submit|preventDefault={handleSubmit}>
      <input
        type="text"
        bind:value={authToken}
        placeholder="Authentication token"
        disabled={loading}
      />
      <button type="submit" disabled={loading || !authToken.trim()}>
        {loading ? "Connecting..." : "Connect"}
      </button>
    </form>
  </div>
</div>

<style>
.auth {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f5f5f5;
  padding: 1rem;
}

.auth-card {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

h2 {
  margin: 0 0 2rem 0;
  color: #333;
}

.btn-primary {
  width: 100%;
  padding: 0.75rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  margin-bottom: 1rem;
}

.btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.divider {
  margin: 1rem 0;
  color: #666;
  font-size: 0.9rem;
}

form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

input {
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

button {
  padding: 0.75rem;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
}

button:disabled {
  background: #ccc;
  cursor: not-allowed;
}
</style>
